const Loader = () => {
  return (
    <>
    <div className="fixed inset-0 flex items-center justify-center bg-white">
    <div className="w-32 h-32 border-[1px] border-primary rounded-full flex items-center justify-center">
        <div className="flex gap-2 text-4xl font-extrabold text-primary">
        <span className="animate-flicker [animation-delay:0s]">P</span>
        <span className="animate-flicker [animation-delay:0.2s]">P</span>
        <span className="animate-flicker [animation-delay:0.4s]">T</span>
        </div>
    </div>
    </div>

</>


  )
}

export default Loader
